import React , { useState, useEffect , useContext} from 'react';
import * as Icon from 'react-bootstrap-icons';
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import './Side.css';
import { AdminContext } from '../../views/admin/AdminContext';

const SideMenu = (props) => {
    const {activeMenu,setActiveMenu} = useContext(AdminContext);

    useEffect( () => {
        console.log(activeMenu);
    },[activeMenu]);



    return(
            <div>
                <a role="button" className='text-decoration-none d-flex align-items-center text-white d-none d-sm-inline'>

                </a>
                <ul className='nav nav-pills flex-column' id="navPa">
                    <li className={"nav-item "  } onClick={ () => {setActiveMenu('panel')}} >
                        <a className={"nav-link text-white "+ (activeMenu == 'panel' ? 'active': '')  } aria-current='page'>
                                <Icon.Speedometer2 />
                            <span className='ms-2 '>Panel</span>
                        </a>
                    </li>
                    <li className={"nav-item "} onClick={ () => {setActiveMenu('campaing')}}>

                        <a className={"nav-link text-white "  + (activeMenu == 'campaing' ? 'active': '')  }>
                            <Icon.QrCodeScan />
                            <span className='ms-2'>Campañas</span>
                        </a>
                    </li>
                    <li className={"nav-item "} onClick={ () => {setActiveMenu('service')}}>
                        <a className={"nav-link text-white "+ (activeMenu == 'service' ? 'active': '') } >
                            <Icon.Tools />
                            <span className='ms-2'>Servicios</span>
                        </a>
                    </li>
                    <li className={"nav-item " } onClick={ () => {setActiveMenu('configuration')}}>

                        <a className={"nav-link text-white "  + (activeMenu == 'configuration' ? 'active': '') } href='#conf-op' data-bs-toggle = "collapse">
                            <Icon.HouseAddFill /><span className="ms-2">Config <Icon.ChevronDown /></span>
                        </a>
                        <ul className="nav collapse ms-1 flex-column" id="conf-op" data-bs-parent="#parentConf">
                            <li className="nav-item "  onClick={ () => {setActiveMenu('users')}}>
                                <a className={"nav-link text-white " + (activeMenu == 'users' ? 'active': '') } href="#" data-bs-toggle = "collapse">
                                    <Icon.People /><span className="ms-2">Usuarios </span>
                                </a>
                            </li>
                            <li className="nav-item " onClick={ () => {setActiveMenu('account')}}>
                                <a className={"nav-link text-white " + (activeMenu == 'account' ? 'active': '') }   href="#" data-bs-toggle = "collapse">
                                    <Icon.Rocket /><span className="ms-2">Cuenta </span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

    )
}
export default SideMenu;